import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { PagesEventService, Url } from "src/app/common";
import { User, UserAuth } from "src/app/common/user-auth";
import { Ticket } from "../models/ticket.model";
import { TicketService } from "../services/ticket.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'app-create-ticket-index',
  templateUrl: '../views/create-ticket.component.html',
  styleUrls: ['../styles/style.css']
})
export class CreateTicketComponent implements OnInit {
  userAuth: User = UserAuth.get();
  url = Url;
  ticket = new Ticket();
  priority = ['low', 'medium', 'high'];
  artArray = [];
  similarTickets = [];
  ticketsGroups = [];
  categoryData = [];
  categorySkynetTicketData = [];
  categoryItTicketData = [];
  itTicketSubcategoryData = [];
  ticketCategory;
  itTicketCategory;
  itTicketSubcategory;
  group_id;
  onSubmit=null;
  selectedType = 'Skynet-Ticket';

  imageEditor = {
    show: false,
    top: 20,
    file: null,
    fileName: null,
    readUrl: null,
    saveUrl: null,
    width: window.innerWidth - 100,
    height: window.innerHeight,
    description: null,
  };



  constructor(private pagesEventService: PagesEventService,
              private router: Router,
              private route: ActivatedRoute,
              public ticketService: TicketService,
              private translateService: TranslateService) {
  }

  ngOnInit(): void {
    this.ticket.user_id = this.userAuth.id;
    this.ticket.status = 'New';
    this.getAllGroups();
    this.getTicketCategories();
    const lang = this.translateService.currentLang || 'de';
    this.ticketService.getArtTypes(lang).subscribe(response => {
      this.artArray = response.ArtTypes;
    });

    this.route.queryParams.subscribe(params => {
      const hasSkynet = 'Skynet-Ticket' in params;
      const hasIT = 'IT-Ticket' in params;

      if(!hasSkynet && !hasIT) {
        this.router.navigate([], {                    // Default to Skynet-Ticket
          relativeTo: this.route,                     // Default to Skynet-Ticket
          queryParams: { 'Skynet-Ticket': true },     // Default to Skynet-Ticket
          queryParamsHandling: 'merge'                // Default to Skynet-Ticket
        });
      }

      if(params['Skynet-Ticket']) {
        this.selectedType = 'Skynet-Ticket';
        this.ticket.type = 'Skynet-Ticket';
      }
      else if (params['IT-Ticket']) {
        this.selectedType = 'IT-Ticket';
        this.ticket.type = 'IT-Ticket';
      }
    });
  }

  getTicketCategories() {
    this.ticketService.getTicketsCategory({}).subscribe((response) => {
      this.categoryData = response.TicketsCategory;
      this.categorySkynetTicketData = this.categoryData.filter(cat => cat.type === 'Skynet-Ticket').sort((a, b) => a.name.localeCompare(b.name));
      this.categoryItTicketData = this.categoryData.filter(cat => cat.type === 'IT-Ticket').sort((a, b) => a.name.localeCompare(b.name));
    });
  }

  getAllGroups() {
    this.ticketService.getAllTicketsGroups().subscribe((response) => {
      this.ticketsGroups = response.TicketsGroup;
      this.ticket.tickets_group_id = response.TicketsGroup[0].id;
    });
  }

  onFilesAdded(event) {
    event.addedFiles.forEach(file => {
      this.ticketService.saveFile(file).subscribe((response) => {
        this.ticket.files = this.ticket.files || [];
        this.openEditor(file, response.File.fileName);
      });
    });
  }

  openEditor(file, fileName) {
    this.imageEditor.file = file;
    this.imageEditor.description = file.description;
    this.imageEditor.fileName = fileName;
    this.imageEditor.readUrl = `/image/${fileName}`;
    this.imageEditor.saveUrl = `/tickets/files`;
    this.imageEditor.show = true;
  }

  onEditorClosed(event) {
    if(event.file !== null) {
      this.ticket.files.push(event.file);
    }
    this.imageEditor.show=false;
  }

  deleteFile(file) {
    this.ticket.files.splice(this.ticket.files.indexOf(file),1);
  }

  submit(value) {
    this.onSubmit = true;
    this.ticketService.createTicket(Ticket.prepare(this.ticket)).subscribe((response) => {
      this.router.navigate(['/ticket']);
    });
  }

  selectedGroup() {
    this.ticket.tickets_group_id = this.group_id.id;
  }

  selectedCategory() {
    this.ticket.ticket_category = this.ticketCategory.name;
    this.ticket.ticket_category_id = this.ticketCategory.id;
  }

  selectedItTicketCategory() {
    this.ticket.ticket_category = this.itTicketCategory.name;
    this.ticket.ticket_category_id = this.itTicketCategory.id;
    this.itTicketSubcategory = null;
    this.ticket.ticket_subcategory = null;
    this.ticket.ticket_subcategory_id = null;
    this.itTicketSubcategoryData = this.categoryData.find(item => item.name === this.ticket.ticket_category)?.subcategory || [];
    this.itTicketSubcategoryData.sort((a, b) => a.name.localeCompare(b.name));
  }

  selectedItTicketSubcategory() {
    this.ticket.ticket_subcategory = this.itTicketSubcategory.name;
    this.ticket.ticket_subcategory_id = this.itTicketSubcategory.id;
  }

  checkForSimilarTickets(event) {
    if(this.ticket.subject == null || this.ticket.subject == '') {
      this.similarTickets = [];
    }
    else {
      this.ticketService.checkForSimilarTickets({subject: this.ticket.subject, type: this.selectedType}).subscribe((response) => {
        this.similarTickets = response.Ticket;
      });
    }
  }

  openTicketInNewTab(id) {
    window.open(`/ticket/view/${id}`, '_blank');
  }

}
